import React, { FC } from 'react'
import AlertFilledIcon from 'transfix-icons/build/AlertFilledIcon'
import CheckFilledIcon from 'transfix-icons/build/CheckFilledIcon'
import { StepIcon, StepIconProps } from 'transfix-ui/core'
import { makeStyles, Theme, createStyles } from 'transfix-ui/core/styles'

const useStepIconStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      border: '2px solid #A9B2BD',
      borderRadius: '50%',
      color: '#F9FAFA',
    },
    active: {
      '&$active': {
        color: '#394657',
        stroke: 'white',
        strokeWidth: 10,
      },
    },
  })
)

export const SidebarEmptyIcon: FC<StepIconProps> = props => {
  const classes = useStepIconStyles()
  return <StepIcon {...props} icon='' classes={classes} />
}

export const SidebarCheckIcon: FC<StepIconProps> = () => {
  const classes = useStepIconStyles()
  return <StepIcon icon={<CheckFilledIcon size='large' color='skyBlue6' />} classes={classes} />
}

export const SidebarErrorIcon: FC<StepIconProps> = () => {
  const classes = useStepIconStyles()
  return <StepIcon icon={<AlertFilledIcon size='large' color='error' />} classes={classes} />
}
